module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmYTI3NzIzMjdmNTVkODE5ODMwMWZkYjhiY2ZjODE1OC53b2ZmIjs="


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = sPdF
// module chunks = 3 5